import { type LucideIcon, CalendarClock, FileOutput } from 'lucide-react';
import { Cell, Legend, Pie, PieChart, Tooltip } from 'recharts';

import { Card, CardContent, CardHeader, CardTitle } from '@/ui/base/card';
import { ChartContainer } from '@/ui/base/chart';

import { CORES_FATIA, ESTILO_TOOLTIP } from './temaGrafico';
import type { FatiaContagem } from './tipos';

function GraficoPizza({
  titulo,
  icone: Icone,
  dados,
}: {
  titulo: string;
  icone: LucideIcon;
  dados: FatiaContagem[];
}) {
  const semDados = dados.every((f) => f.valor === 0);

  return (
    <Card className="overflow-hidden rounded-2xl border border-border/60">
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2.5">
          <div className="rounded-lg bg-orange/10 p-1.5">
            <Icone className="h-4 w-4 text-orange" aria-hidden />
          </div>
          <CardTitle className="text-sm font-bold">{titulo}</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        {semDados ? (
          <p className="py-12 text-center text-sm text-muted-foreground">Sem dados no período.</p>
        ) : (
          <ChartContainer config={{}} className="aspect-auto h-72 w-full">
            <PieChart>
              <Pie
                data={dados}
                dataKey="valor"
                nameKey="nome"
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={85}
                strokeWidth={2}
                stroke="hsl(var(--card))"
                label={({ name, value }: { name: string; value: number }) => `${name}: ${value}`}
              >
                {dados.map((fatia, i) => (
                  <Cell key={fatia.nome} fill={CORES_FATIA[i % CORES_FATIA.length]} />
                ))}
              </Pie>
              <Tooltip contentStyle={ESTILO_TOOLTIP} />
              <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: '11px' }} />
            </PieChart>
          </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
}

/** Dois gráficos de pizza: status dos prazos e funil de documentos × lotes. */
export function StatusPrazosEFunil({
  statusPrazos,
  funilDocumentos,
}: {
  statusPrazos: FatiaContagem[];
  funilDocumentos: FatiaContagem[];
}) {
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <GraficoPizza titulo="Status dos prazos" icone={CalendarClock} dados={statusPrazos} />
      <GraficoPizza titulo="Funil documentos × lotes" icone={FileOutput} dados={funilDocumentos} />
    </div>
  );
}
